import { CODING_COLUMNS_BY_TYPE, type CodingColumnId, type CodingType } from 'app/util/columnVisibility';

// SEE-1091 — per-type coding fields for the reimbursement coding sheets.
// GL Code + Vendor are common to every type; the selected type adds its own
// group on top. Reimbursement-specific (NOT the shared transactions
// CODING_COLUMNS_BY_TYPE, where GL is glCode-only): keeping GL Code on every
// type is a reimbursement requirement. Order drives render order; the set is
// intersected with the admin's configured visibleColumnIds at the call site.
//
// Lives in its own module (not reimbursements/utils.tsx) so the columnVisibility
// import chain isn't pulled into utils.tsx, which is imported across the app
// (incl. mobile) and is sensitive to circular imports.
export const REIMBURSEMENT_CODING_TYPE_COLUMNS: Record<CodingType, CodingColumnId[]> = {
  gl: ['glCode', 'vendor'],
  project: ['glCode', ...CODING_COLUMNS_BY_TYPE.project, 'vendor'],
  equipment: ['glCode', ...CODING_COLUMNS_BY_TYPE.equipment, 'vendor'],
};

export const REIMBURSEMENT_CODING_TYPE_OPTIONS: { value: CodingType; label: string }[] = [
  { value: 'gl', label: 'GL' },
  { value: 'project', label: 'Project' },
  { value: 'equipment', label: 'Equipment' },
];

/** Resolve the coding type to DISPLAY for a reimbursement. An explicit stored
 *  codingType (UPPERCASE) always wins. When it's absent — e.g. a record coded
 *  before the type selector shipped — derive from the coding actually applied
 *  (equipment > project > gl) so the read-only detail sheet doesn't collapse a
 *  project/equipment-coded record to GL-only and hide its real coding. */
export const resolveReimbursementCodingType = (
  stored?: string | null,
  coding?: { agaveEquipment?: unknown; agaveProject?: unknown } | null
): CodingType => {
  const normalized = (stored ?? '').toLowerCase();
  if (normalized === 'project' || normalized === 'equipment' || normalized === 'gl') {
    return normalized as CodingType;
  }
  if (coding?.agaveEquipment) return 'equipment';
  if (coding?.agaveProject) return 'project';
  return 'gl';
};
